module.exports = __webpack_public_path__ + "assets/1867104c516bc351d583e7831b5643d2.png";